import request from "../../utils/request";

export function doGetAllCompanyAdmins(params) {
  return request("/company-admins", {
    method: "GET",
    params,
  });
}

export function doCreateCompanyAdmin(params) {
  return request("/company-admins", {
    method: "POST",
    data: params,
  });
}

export function doUpdateCompanyAdmin(params) {
  return request(`/company-admins/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doGetAllPartnerCompanyAdmins(params) {
  return request("/partner-company-admins", {
    method: "GET",
    params,
  });
}

export function doCreatePartnerCompanyAdmin(params) {
  return request("/partner-company-admins", {
    method: "POST",
    data: params,
  });
}

export function doUpdatePartnerCompanyAdmin(params) {
  return request(`/partner-company-admins/${params.id}`, {
    method: "PUT",
    data: params,
  });
}
